import { FormControl as FormControl$1 } from './src/FormControl.js';
import HelperText from './src/HelperText.js';

const FormControl = FormControl$1;
FormControl.HelperText = HelperText;

export { FormControl };
//# sourceMappingURL=index.js.map
